import React, { useEffect, useState } from "react";
import { MdMoreVert } from "react-icons/md";
import { FaPlus } from "react-icons/fa";

const ManageAddresses = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    pincode: "",
    locality: "",
    address: "",
    city: "",
    state: "",
    landmark: "",
  });

  const token =
    localStorage.getItem("access_token") ||
    localStorage.getItem("access") ||
    localStorage.getItem("jwt");

  // -------------------- LOAD SAVED ADDRESSES --------------------
  useEffect(() => {
    fetch("https://hrgf.salepatner.com/api/addresses/", {
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    })
      .then((res) => res.json())
      .then((data) => setAddresses(data))
      .catch(() => setAddresses([]))
      .finally(() => setLoading(false));
  }, []);

  // -------------------- SAVE NEW ADDRESS --------------------
  const handleSave = async (e) => {
    e.preventDefault();

    const res = await fetch("https://hrgf.salepatner.com/api/addresses/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify(form),
    });

    if (!res.ok) {
      alert("❌ Failed to save address");
      return;
    }

    const newAddress = await res.json();
    setAddresses([...addresses, newAddress]);

    setShowForm(false);
    setForm({
      name: "",
      phone: "",
      pincode: "",
      locality: "",
      address: "",
      city: "",
      state: "",
      landmark: "",
    });

    alert("✅ Address saved successfully");
  };

  return (
    <div className="w-full bg-white rounded-lg shadow border p-6">

      {/* TOP SECTION BUTTON */}
      <div
        className="border p-4 rounded-lg cursor-pointer hover:bg-gray-50 flex items-center gap-3 font-semibold text-blue-600 mb-6"
        onClick={() => setShowForm(true)}
      >
        <FaPlus className="text-lg" />
        ADD A NEW ADDRESS
      </div>

      {/* ---------- FORM ----------- */}
      {showForm && (
        <form
          className="p-6 bg-blue-50 rounded-lg mb-6"
          onSubmit={handleSave}
        >
          <h3 className="font-semibold mb-4 text-gray-800">
            ADD A NEW ADDRESS
          </h3>

          <div className="grid grid-cols-2 gap-4">
            <input
              placeholder="Full Name"
              className="border p-2 rounded"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />

            <input
              placeholder="10-digit mobile number"
              className="border p-2 rounded"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              required
            />

            <input
              placeholder="Pincode"
              className="border p-2 rounded"
              value={form.pincode}
              onChange={(e) => setForm({ ...form, pincode: e.target.value })}
              required
            />

            <input
              placeholder="Locality"
              className="border p-2 rounded"
              value={form.locality}
              onChange={(e) => setForm({ ...form, locality: e.target.value })}
            />
          </div>

          <textarea
            placeholder="Address (Area and Street)"
            rows="2"
            className="border p-2 rounded w-full mt-4"
            value={form.address}
            onChange={(e) => setForm({ ...form, address: e.target.value })}
            required
          ></textarea>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <input
              placeholder="City/District/Town"
              className="border p-2 rounded"
              value={form.city}
              onChange={(e) => setForm({ ...form, city: e.target.value })}
              required
            />

            <input
              placeholder="State"
              className="border p-2 rounded"
              value={form.state}
              onChange={(e) => setForm({ ...form, state: e.target.value })}
              required
            />
          </div>

          <input
            placeholder="Landmark (Optional)"
            className="border p-2 rounded w-full mt-4"
            value={form.landmark}
            onChange={(e) => setForm({ ...form, landmark: e.target.value })}
          />

          <div className="flex gap-4 mt-6">
            <button
              type="submit"
              className="bg-blue-600 text-white px-5 py-2 rounded"
            >
              SAVE
            </button>
            <button
              type="button"
              className="text-blue-600"
              onClick={() => setShowForm(false)}
            >
              CANCEL
            </button>
          </div>
        </form>
      )}

      {/* ------------ EXISTING SAVED ADDRESSES ------------ */}
      {loading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : (
        addresses.map((addr) => (
          <div
            key={addr.id}
            className="border rounded-lg p-5 mb-4 bg-white relative"
          >
            <div className="absolute right-4 top-4 cursor-pointer text-gray-500">
              <MdMoreVert size={22} />
            </div>

            <span className="px-3 py-1 bg-gray-100 rounded text-gray-800 text-xs">
              HOME
            </span>

            <p className="font-semibold text-gray-800 mt-3">
              {addr.name} — {addr.phone}
            </p>

            <p className="text-gray-600 mt-2 text-sm">
              {addr.address}, {addr.city}, {addr.state} - <b>{addr.pincode}</b>
            </p>
          </div>
        ))
      )}
    </div>
  );
};

export default ManageAddresses;
